module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }